enum Channel {
    US = 'petsmart-us',
    CA = 'petsmart-ca',
}

export { Channel };
